// Product Collections Getters

export const getCollectionList = state => {
  return state.collectionList
}

export const getCollectionInfo = state => {
  return state.collectionInfo
}
